import { Flex } from "@chakra-ui/react"
import { EntityId } from "@jackfruit/common"
import React from "react"
import { CloudImage } from "../../CloudProviderTypes"
import CloudImageBrowser from "../../common/browser/CloudImageBrowser"
import CloudImageBrowserActionsDesktop from "../../common/browser/CloudImageBrowserActionsDesktop"
import CloudImageBrowserLoader from "../../common/browser/CloudImageBrowserLoader"
import VNZImageSelector from "./VNZImageSelector"

interface Props {
  isLoading: boolean
  allImages: CloudImage[]
  selectedImageIds: EntityId[]
  handleImageSelect: (image: EntityId) => void
  isImportingImages: boolean
  hasSelectedImages: boolean
  handleUploadImages: () => void
  closeCloudProviderModal: () => void
}

const VNZImageBrowserDesktop: React.FC<Props> = ({
  isLoading,
  allImages,
  selectedImageIds,
  handleImageSelect,
  closeCloudProviderModal,
  handleUploadImages,
  hasSelectedImages,
  isImportingImages,
}) => {
  return (
    <Flex flexDirection="column" flex={1}>
      <Flex height="500px" overflowY="scroll" p={4} pt={0} pl={0}>
        {isLoading && <CloudImageBrowserLoader />}
        {!isLoading && (
          <CloudImageBrowser
            images={allImages}
            onImageSelect={handleImageSelect}
            selectedImageIds={selectedImageIds}
            imageComponent={VNZImageSelector}
          />
        )}
      </Flex>
      <CloudImageBrowserActionsDesktop
        selectedImageIds={selectedImageIds}
        isImportingImages={isImportingImages}
        hasSelectedImages={hasSelectedImages}
        handleUploadImages={handleUploadImages}
        closeCloudProviderModal={closeCloudProviderModal}
      />
    </Flex>
  )
}

export default VNZImageBrowserDesktop
